import React from "react";
import FormError from "../formError/FormError";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";

const ClientFormContact = ({
  client,
  onChange,
  allow,
  translate,
  form,
  readOnly,
}) => (
  <>
    <div>
      <label className="label">{translate("contact-name")}</label>
      <input
        type="text"
        name="contactName"
        value={client.contactName}
        onChange={onChange}
        className="input"
        disabled={readOnly}
      />
      <FormError form={form} name="contactName" />
    </div>
    <div>
      <div className="flex items-center gap-4 mb-2">
        <label className="label">Email</label>
        <div
          className={`flex items-center px-2 py-1 rounded ${
            client.verificationEmail
              ? "bg-blue-500"
              : "bg-slate-900 dark:bg-slate-300"
          }`}
        >
          <input
            name="verificationEmail"
            type="checkbox"
            className="mr-2"
            onChange={onChange}
            checked={!!client.verificationEmail}
            disabled={readOnly}
          />
          <span
            className={`text-xs ${
              client.verificationEmail
                ? "text-white"
                : "text-white dark:text-gray-900 "
            }`}
          >
            {translate("verify-email")}
          </span>
        </div>
      </div>
      <input
        type="email"
        name="email"
        value={client.email}
        onChange={onChange}
        className="input"
        disabled={readOnly}
      />
      <FormError form={form} name="email" />
    </div>
    <div>
      <div className="flex items-center gap-4 mb-2">
        <label className="label">{translate("phone-number")}</label>
        <div
          className={`flex items-center px-2 py-1 rounded ${
            client.verificationPhoneNumber
              ? "bg-blue-500"
              : "bg-slate-900 dark:bg-slate-300"
          }`}
        >
          <input
            name="verificationPhoneNumber"
            type="checkbox"
            className="mr-2"
            onChange={onChange}
            checked={!!client.verificationPhoneNumber}
            disabled={readOnly}
          />
          <span
            className={`text-xs ${
              client.verificationPhoneNumber
                ? "text-white"
                : "text-white dark:text-gray-900 "
            }`}
          >
            {translate("verify-phone-number")}
          </span>
        </div>
      </div>
      <input
        type="tel"
        name="phoneNumber"
        value={client.phoneNumber}
        onChange={onChange}
        required
        className="input"
        disabled={readOnly}
      />
      <FormError form={form} name="phoneNumber" />
    </div>
    {!IsAllow(allow, "customer-01") && (
      <div>
        <label className="label">{translate("ext-phone-number")}</label>
        <input
          type="tel"
          name="extPhoneNumber"
          value={client.extPhoneNumber}
          onChange={onChange}
          className="input"
          disabled={readOnly}
        />
        <FormError form={form} name="extPhoneNumber" />
      </div>
    )}
  </>
);

export default ClientFormContact;
